import React, { cloneElement, useContext, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFileAlt } from '@fortawesome/free-solid-svg-icons';

import {
  IconPrinter,
  IconPencil,
  IconFileText,
} from '@tabler/icons';

import BlueTitleRow from '../../ui/BlueTitleRow';
import IfmsModal from '../../ui/IfmsModal';

import LabeledSelect from '../../ui/LabeledSelect';
import CheckBoxIcon from '../../ui/CheckBoxIcon';

import {
  billInsideAccordionLineItems,
  invoiceInsideAccordionLineItems,
  crdbInsideAccordionLineItems,
  ApplicableTableSettings,
  billPreviewLineItems,
  billOrInvoiceSummaryLineItems,
  otherShipmentBillOrInvoiceSummaryLineItems,
  crdbSummaryLineItems,
  otherShipmentCrdbSummaryLineItems,
  invoiceInsideAccordionLineItems_noCrDb,
  billInsideAccordionLineItems_noCrDb,
  billInsideAccordionLineItems_noCrDbWithDo,
  billOrInvoiceSummaryLineItems_noCrDb
} from '../../tableSettings';
import { DocumentType } from '../../framework.core/DocumentType';
import SmartTable from '../../uiControls/SmartTable';
import UniqueLinkButton from '../../uiControls/UniqueLinkButton';

import useTableStorage, { TableStorage } from '../../hooks/useTableStorage';
import useSystemSettings from '../../hooks/useSystemSettings';

import WhiteButton from '../../ui/WhiteButton';
import PrimaryButton from '../../ui/PrimaryButton';
import LabeledFloat from '../../ui/LabeledFloat';

import {
  InvoiceBillCrdb,
  SalesCostPendingItem,
  SystemSettings
} from '../../ifmsTypes';
import { ScreenStackItem } from '../../features/screenStackSlice';
import { formatDate, getDiffDays, now } from '../../dateUtils';
import { getJobNameByTbName, isHouseJob, JobNames } from '../../framework.core/JobNames';
import { ApHd } from '../../fms.core/ApHd';
import { InvoHd } from '../../fms.core/InvoHd';
import ApplicationContext from '../../ApplicationContext';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import { SalesCostCrDb } from '../../fms.data/models/SalesCostCrDb';
import { FloatRenderer, NullableBlackCheckboxIconRenderer } from '../../uiControls/SmartTableRenderers';
import SecondaryButton from '../../ui/SecondaryButton';
 import { getFmsGlobal } from '../../globals';
 import { GetOpUsedAgents } from './utils/OpFunc';
import { CRDBArgs, InvoiceArgs } from '../../fms.report/args';
import useReportViewer from '../../hooks/useReportViewer';
import PrintBill from '../accounting/bill/report/PrintBill';
import { ActionButtonItem } from '../../ui/ActionButton';
import IfmsButton from '../../ui/IfmsButton';
import { getDecimal } from '../../util';
import numeral from 'numeral';
import { shouldLockShipmentTypeField } from './utils/OiMDetailView';
import CopyInvoice from '../accounting/common/CopyInvoice';
import BTLocalDODetailInfo from '../brokerageTrucking/localDO/implementation/BTLocalDODetailInfo';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';

import billingOverallInconGray from '../../img/billing-overall-gray.svg';
import billingOverallInconWhite from '../../img/billing-overall-white.svg';
import billingOverallIncon from '../../img/billing-overall.svg';
import Label from '../../ui/Label';

const HighlightColor = '#c2e6ff';
export type ParentType = JobNames.OIHbl | JobNames.OIMbl | JobNames.OEHbl | JobNames.OEMbl | JobNames.AIHbl | JobNames.AIMbl | JobNames.AEHbl | JobNames.AEMbl | JobNames.OtherOP |
  JobNames.WHRcv | JobNames.WHShip | JobNames.BTOrder | JobNames.BTLoadPlan | JobNames.BTDo;

const EditIcon = () => <span data-tooltip="Edit" ><IconPencil size={15} color="#0f79ff" /></span>;
const PrintIcon = () => <span data-tooltip="Print" ><IconPrinter size={15} color="#0f79ff" /></span>;
const PrintIconDisabled = () => <span data-tooltip="Print" ><IconPrinter size={15} color="#ababab" /></span>;
//const ViewIcon = () => <FontAwesomeIcon style={{fontSize: '13px'}} icon={faFileAlt} data-tooltip="View" />;
const ViewIcon = () => <span data-tooltip="View" ><IconFileText size={15} color="#0f79ff" /></span>;
function IndicatorRenderer() {
  return <div style={{height: '100%'}}></div>;
}

interface Preportargs{
  subj: string,
  tbName:string,
  tbIds:string,
  userID:string,
  docType:DocumentType,
}

export interface BillInvoDetailsSummary {
  id: number,
  type: string|undefined,
  billInvoId: number,
  no: string|undefined,
  date: string|undefined,
  entity: string|undefined,
  entityCur: string|undefined,
  billingCode: string|undefined,
  itemDescriptionCode: string|undefined,
  rate: number|undefined,
  cur: string|undefined,
  qty: number|undefined,
  amount: number|undefined,
  localAmount: number|undefined,
  agent: string|undefined,
  agentCur: string|undefined,
  agentAmount: number|undefined,
  crdbNo: string|undefined,
  total: number|undefined,
  balance: number|undefined,
  tbName: string|undefined,
  parentId: string|undefined,
  void: boolean,
  draft: boolean,
  isPending: boolean,
};

export interface CrdbDetailsSummary {
  id: number,
  type: string|undefined,
  crdbId: number,
  crdbNo: string|undefined,
  crdbDate: string|undefined,
  agent: string|undefined,
  billingCode: string|undefined,
  itemDescriptionCode: string|undefined,
  cur: string|undefined,
  credit: number|undefined,
  debit: number|undefined,
  crdbAmount: number|undefined,
  tbName: string|undefined,
  parentId: string|undefined,
  total: number|undefined,
  balance: number|undefined,
  void: boolean,
  draft: boolean,
  blNo: string|undefined,
  ps: boolean,
};

export interface SalesCostSummary {
  billSummary: Array<Array<BillInvoDetailsSummary>>,
  invoiceSummary: Array<Array<BillInvoDetailsSummary>>,
  crdbSummary: Array<Array<CrdbDetailsSummary>>
};

export function BillInvoiceSummaryTable({
  summary,
  isInvoice,
  height,
  isNoLink,
  hideCrdb = false,
}:{
  summary: Array<Array<BillInvoDetailsSummary>>,
  isInvoice: boolean,
  height?: string | undefined
  isNoLink?: boolean,
  hideCrdb?: boolean,
}) {
  const data:Array<any> = [];

  const systemSettings = useSystemSettings();
  const primaryCurrency = systemSettings.primaryCurrency ?? 'USD';

  const tbNameType: Record<string, string> = {
    "T_OIMMAIN": "M",
    "T_OIHMAIN": "H",
    "T_OOMMAIN": "M",
    "T_OOHMAIN": "H",
    "T_AIMMAIN": "M",
    "T_AIHMAIN": "H",
    "T_AOMMAIN": "M",
    "T_AOHMAIN": "H",
    "T_WRECEIVE": "WHR",
    "T_WSHIPHD": "WHS",
    "T_BTLOAD": "L",
    "T_BTORDER": "M",
  };

  const tbNameSuffix: Record<string, string> = {
    "T_OIMMAIN": ".OI",
    "T_OIHMAIN": ".OI",
    "T_OOMMAIN": ".OE",
    "T_OOHMAIN": ".OE",
    "T_AIMMAIN": ".AI",
    "T_AIHMAIN": ".AI",
    "T_AOMMAIN": ".AE",
    "T_AOHMAIN": ".AE",
    "T_GENMAIN": ".OT",
    "T_WRECEIVE": ".WH",
    "T_WSHIPHD": ".WH",
    "T_BTORDER": ".OD",
    "T_BTLOAD": ".OD",
  };

  function InvoBillNoRenderer({ data, row, cell }: any) {
    const history = useHistory();
    const l = data[row.index];

    function openLink() {
      if (l.billInvoId > 0 && l.no) {
        const url = getLinkUrl();
        if (url) {
          openNewPage(history, url, NavigationType.newPage);
        }
      }
    }

    function getLinkUrl(): string {
      if (isInvoice) {
        return `/accounting/invoice/view/${getJobNameByTbName(l.tbName)}/${l.parentId}/${l.billInvoId}`
      } else {
        return `/accounting/bill/view/${getJobNameByTbName(l.tbName)}/${l.parentId}/${l.billInvoId}`
      }  
    }

    return (
      <div className="ifms-table-align-left" style={{ width: '100%', color: 'blue', cursor: 'pointer', fontWeight: 600, }} onClick={openLink}>
        {cell.value}
      </div>
    );
  }

  summary.forEach(x => {
    x.forEach((element, i) => {
      let type = tbNameType[element.tbName ?? ''] || '';
      let billingcodeSuffix = tbNameSuffix[element.tbName ?? ''] || '';
      let billingCodeView = element.billingCode?.replace(billingcodeSuffix, '') || ''; 

      data.push({
        ...element,
        type: i === 0 ? type : '',
        no: i === 0 ? element.no : '',
        date: i === 0 ? element.date : '',
        entity: i === 0 ? element.entity : '',
        void: i === 0 ? element.void : false,
        draft: i === 0 ? element.draft : false,
        isLast: i === x.length - 1,
        billingCode: billingCodeView,
      });
    });
  });

  //const tableSettings = summary.some(Array => Array.some(item => item.tbName === 'T_GENMAIN')) ? {...otherShipmentBillOrInvoiceSummaryLineItems} : {...billOrInvoiceSummaryLineItems};
  const tableSettings = hideCrdb ? {...billOrInvoiceSummaryLineItems_noCrDb} : {...billInsideAccordionLineItems};
  
  const tableOptions: ApplicableTableSettings = {
    tableName: `${isInvoice ? 'invoice' : 'bill'}SummaryLineItems `,
    ...tableSettings,
    // height: '350px',
    height: height?? '350px',
    data,
    rowRenderers: [
      // { accessor: 'no', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.no ?? ''), Header: () => isInvoice ? 'Invoice #' : 'Bill #' },
      { accessor: 'type', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.type ?? ''), Header: 'Type' },
      { accessor: 'no', Cell: isNoLink ? InvoBillNoRenderer : ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.no ?? ''), Header: () => isInvoice ? 'Invoice #' : 'Bill #' },
      { accessor: 'date', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.date), Header: () => isInvoice ? 'Invoice Date' : 'Bill Date' },
      { accessor: 'entity', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.entity ?? ''), Header: () => isInvoice ? 'Customer' : 'Vendor' },
      { accessor: 'billingCode', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billingCode ?? '') },
      { accessor: 'itemDescription', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.itemDescription ?? '') },
      { accessor: 'draft', Cell: (props:any) => <NullableBlackCheckboxIconRenderer {...props} />  },
      { accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur ?? '') },
      { accessor: 'rate', Cell: (props:any) => <FloatRenderer decimals={4} {...props} /> },
      { accessor: 'qty', Cell: (props: any) => <FloatRenderer decimals={4} {...props} /> },
      { accessor: 'amount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.amount, cell.row.original.cur) },
      { Header: `${primaryCurrency} Amount`, accessor: 'localAmount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.localAmount, cell.row.original.entityCur) },
      { accessor: 'agent', Cell: ({ cell }: any) => TextLeftRenderer(cell.row.original, (x: any) => x.agent ?? '') },
      { accessor: 'agentCur', Cell: ({ cell }: any) => TextRenderer(cell.row.original, (x: any) => x.agentCur ?? '') },
      { accessor: 'agentAmount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.agentAmount, cell.row.original.agentCur) },
      { accessor: 'crdbNo', Cell: ({cell}:any) => CrdbNoRenderer(cell.row.original, (x:any) => x.crdbNo ?? '',(x:any) => x.isPending ?? '') },
    ],
    rowProps: (row: any) => {
      return {
        rowextras: row.original.isLast
          ? 
          // <div style={{backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px'}}>
          //   <span style={{paddingLeft: '800px', paddingRight:'15px'}}>Total</span>
          //   <div style={{ textAlign: 'right' }}>{CurrencyRenderer(row.original.total, row.original.entityCur, true)}</div>
          //   <span style={{paddingLeft: '20px', paddingRight:'5px'}}>Balance: </span>
          //   <div style={{ textAlign: 'right', display: 'flex'}}>{CurrencyRenderer(row.original.balance, row.original.entityCur, true)}</div>  
          // </div>

          <div style={{ backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px' }}>
            <span style={{ paddingLeft: '800px', paddingRight: '5px' }}>Total</span>
            <div style={{ textAlign: 'end', width: '50px' }}>
              {CurrencyRenderer(row.original.total, row.original.entityCur, true)}
            </div>
            <span style={{ paddingLeft: '30px', paddingRight: '5px' }}>Balance: </span>
            <div style={{ textAlign: 'end', width: '30px' }}>
              {CurrencyRenderer(row.original.balance, row.original.entityCur, true)}
            </div>
          </div>
          : undefined,
      };
    },
  };

  const tableOptions_noCrDb: ApplicableTableSettings = {
    tableName: `${isInvoice ? 'invoice' : 'bill'}SummaryLineItems_noCrDb `,
    ...billOrInvoiceSummaryLineItems_noCrDb,
    // height: '350px',
    height: height?? '350px',
    data,
    rowRenderers: [
      // { accessor: 'no', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.no ?? ''), Header: () => isInvoice ? 'Invoice #' : 'Bill #' },
      { accessor: 'type', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.type ?? ''), Header: 'Type' },
      { accessor: 'no', Cell: isNoLink ? InvoBillNoRenderer : ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.no ?? ''), Header: () => isInvoice ? 'Invoice #' : 'Bill #' },
      { accessor: 'date', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.date), Header: () => isInvoice ? 'Invoice Date' : 'Bill Date' },
      { accessor: 'entity', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.entity ?? ''), Header: () => isInvoice ? 'Customer' : 'Vendor' },
      { accessor: 'billingCode', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billingCode ?? '') },
      { accessor: 'itemDescription', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.itemDescription ?? '') },
      { accessor: 'draft', Cell: (props:any) => <NullableBlackCheckboxIconRenderer {...props} />  },
      { accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur ?? '') },
      { accessor: 'rate', Cell: (props:any) => <FloatRenderer decimals={4} {...props} /> },
      { accessor: 'qty', Cell: (props: any) => <FloatRenderer decimals={4} {...props} /> },
      { accessor: 'amount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.amount, cell.row.original.cur) },
      { Header: `${primaryCurrency} Amount`, accessor: 'localAmount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.localAmount, cell.row.original.entityCur) },
    ],
    rowProps: (row: any) => {
      return {
        rowextras: row.original.isLast
          ? 
          // <div style={{backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px'}}>
          //   <span style={{paddingLeft: '800px', paddingRight:'15px'}}>Total</span>
          //   <div style={{ textAlign: 'right' }}>{CurrencyRenderer(row.original.total, row.original.entityCur, true)}</div>
          //   <span style={{paddingLeft: '20px', paddingRight:'5px'}}>Balance: </span>
          //   <div style={{ textAlign: 'right', display: 'flex'}}>{CurrencyRenderer(row.original.balance, row.original.entityCur, true)}</div>  
          // </div>

          <div style={{ backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px' }}>
            <span style={{ paddingLeft: '990px', paddingRight: '5px' }}>Total</span>
            <div style={{ textAlign: 'end', width: '50px' }}>
              {CurrencyRenderer(row.original.total, row.original.entityCur, true)}
            </div>
            <span style={{ paddingLeft: '30px', paddingRight: '5px' }}>Balance: </span>
            <div style={{ textAlign: 'end', width: '30px' }}>
              {CurrencyRenderer(row.original.balance, row.original.entityCur, true)}
            </div>
          </div>
          : undefined,
      };
    },
  };
  
  return (
    <div style={{marginLeft: '20px', marginRight: '20px'}}>
      {hideCrdb ? 
        <SmartTable {...tableOptions_noCrDb} />
        :
        <SmartTable {...tableOptions} />
      }
    </div>
  );
}


export function CrDbSummaryTable({
  summary,
  height,
  parentType,
  isNoLink,
}:{
  summary: Array<Array<CrdbDetailsSummary>>,
  height?: string | undefined,
  parentType: ParentType,
  isNoLink?: boolean,
}) {
  const data:Array<any> = [];

  const tbNameType: Record<string, string> = {
    "T_OIMMAIN": "M",
    "T_OIHMAIN": "H",
    "T_OOMMAIN": "M",
    "T_OOHMAIN": "H",
    "T_AIMMAIN": "M",
    "T_AIHMAIN": "H",
    "T_AOMMAIN": "M",
    "T_AOHMAIN": "H",
    "T_WRECEIVE": "WHR",
    "T_WSHIPHD": "WHS",
  };
  
  const billingcodeSuffix: Record<string, string> = {
    "T_OIMMAIN": ".OI",
    "T_OIHMAIN": ".OI",
    "T_OOMMAIN": ".OE",
    "T_OOHMAIN": ".OE",
    "T_AIMMAIN": ".AI",
    "T_AIHMAIN": ".AI",
    "T_AOMMAIN": ".AE",
    "T_AOHMAIN": ".AE",
    "T_GENMAIN": ".OT",
    "T_WRECEIVE": ".WH",
    "T_WSHIPHD": ".WH",
  };


  function CrDbNoRenderer({ data, row, cell }: any) {
    const history = useHistory();
    const l = data[row.index];
    const opType = getJobNameByTbName(data[row.index].tbName);

    function openLink() {
      if (l.crdbId > 0 && l.crdbNo) {
        const url = `/accounting/crdb/view/${opType}/${l.parentId}/${l.crdbId}`
        if (url) {
          openNewPage(history, url, NavigationType.newPage);
        }
      }
    }

    return (
      <div className="ifms-table-align-left" style={{ width: '100%', color: 'blue', cursor: 'pointer', fontWeight: 600, }} onClick={openLink}>
        {cell.value}
      </div>
    );
  }

  summary.forEach(x => {
    x.forEach((element, i) => {
      let type = tbNameType[element.tbName ?? ''] || '';
      let suffix = billingcodeSuffix[element.tbName ?? ''] || '';
      let billingCodeView = element.billingCode?.replace(suffix, '') || ''; 

      data.push({
        ...element,
        type: i === 0 ? type : '',
        crdbNo: i === 0 ? element.crdbNo : '',
        crdbDate: i === 0 ? element.crdbDate : '',
        agent: i === 0 ? element.agent : '',
        void: i === 0 ? element.void : false,
        draft: i === 0 ? element.draft : false,
        blNo: i === 0 ? element.blNo : '',
        isLast: i === x.length - 1,
        billingCode: billingCodeView,
      });
    });
  });

  let colName = 'B/L #'
  if(parentType === JobNames.OtherOP) colName = 'Ref #';
  else if(parentType === JobNames.WHRcv) colName = 'Receiving ID';
  else if(parentType === JobNames.WHShip) colName = 'Shipping ID';

  const tableSettings = summary.some(Array => Array.some(item => item.tbName === 'T_GENMAIN')) ? {...otherShipmentCrdbSummaryLineItems} : {...crdbSummaryLineItems};

  const tableOptions: ApplicableTableSettings = {
    tableName: 'crdbSummaryLineItems',
    ...tableSettings,
    // height: '350px',
    height: height ?? '350px',
    data,
    rowRenderers: [
      // { accessor: 'crdbNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.crdbNo ?? '') },
      { accessor: 'type', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.type ?? ''), Header: 'Type' },
      { accessor: 'crdbNo', Cell: isNoLink ? CrDbNoRenderer : ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.crdbNo ?? '') },
      { accessor: 'crdbDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.crdbDate) },
      { accessor: 'agent', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.agent ?? '') },
      { accessor: 'billingCode', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billingCode ?? '') },
      { accessor: 'itemDescription', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.itemDescription ?? '') },
      { accessor: 'draft', Cell: (props:any) => <NullableBlackCheckboxIconRenderer {...props} /> },
      { accessor: 'cur', Cell: ({ cell }: any) => TextRenderer(cell.row.original, (x: any) => x.cur ?? '') },
      { accessor: 'debit', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.debit, cell.row.original.cur) },
      { accessor: 'credit', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.credit, cell.row.original.cur) },
      { accessor: 'crdbAmount', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.crdbAmount, cell.row.original.cur) },
      { accessor: 'ps', Cell: (props:any) => <NullableBlackCheckboxIconRenderer {...props} />  },
      { accessor: 'blNo', Cell: ({ cell }: any) => TextLeftRenderer(cell.row.original, (x: any) => x.blNo ?? ''), Header: () => colName },
    ],
    rowProps: (row: any) => {
      return {
        rowextras: row.original.isLast
          ? 
          // <div style={{backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px'}}>
          //   <div style={{paddingLeft: '800px'}}>Total</div>
          //   <div style={{width: '50px', textAlign: 'right'}}><CurrencyLabel value={row.original.total} currency={row.original.cur} showZero='true' /></div>

          //   <div style={{width: '100px', textAlign: 'right'}}>Balance: <CurrencyLabel value={row.original.balance} currency={row.original.cur} showZero='true' /></div>
          // </div>
          
          <div style={{ backgroundColor: 'white', fontWeight: 'bold', display: 'flex', paddingTop: '6px', paddingBottom: '2px' }}>
            <span style={{ paddingLeft: '800px', paddingRight: '5px' }}>Total</span>
            <div style={{ textAlign: 'end', width: '50px' }}>
              {CurrencyRenderer(row.original.total, row.original.cur, true)}
            </div>
            <span style={{ paddingLeft: '30px', paddingRight: '5px' }}>Balance: </span>
            <div style={{ textAlign: 'end', width: '30px' }}>
              {CurrencyRenderer(row.original.balance, row.original.cur, true)}
            </div>
          </div>
          : undefined,
      };
    },
  };
  
  return (
    <div  style={{marginLeft: '20px', marginRight: '20px'}}>
      <SmartTable {...tableOptions} />
    </div>
  );
}

function BillActionRenderer(
  parentId: number,
  parentType: ParentType,
  data:any,
  row:any,
  isView:boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  setSelectedPopupMenuItem: (x:ActionButtonItem | null) => void,
  showOrderNo:boolean = false,
) {
  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/edit/${parentType}`)
    )
  );

  function print(billId: number) {
    if (data[row.index].draft) return;
    // window.open('http://cloud.suntekscm.co.kr/reports', '_blank')!.focus();
    //viewReport('bill');
    // viewReport(new ReportArgs.NewAgingCommonArgs({
    //   formCaption: 'Customer Outstanding Summary',
    //   endingDate: '2022-02-14T00:00:00',
    //   showBalanceOnly: true,
    //   showCurrency: true,
    //   subject: 'aaa',
    //   type: 'ARW'
    // }));
    setSelectedPopupMenuItem({ label: 'Print Bill', popupComponent: <PrintBill selectedElement={data[row.index]} /> })
  }

  return (
    <div style={{ height: '25px', paddingTop: '2px', display: 'flex' }}>
      {!isView &&
        <UniqueLinkButton name={`bill-edit-button-${row.index}`} display="white" size="regular" style={{ padding: '0px 8px' }}
          link={`/accounting/bill/edit/${parentType}/${parentId}/${data[row.index].id}${showOrderNo? '?DO=true': ''}`} label={<EditIcon />}
          uniqueLinkPrefixQuery={cannotOpen} beforeRedirect={() => beforeBillInvoiceCrdbOpen('bill', 'edit')} 
          goToAlreadyOpenPage />
      }
      {isView &&
        <UniqueLinkButton name={`bill-edit-button-${row.index}`} display="white" size="regular" style={{ padding: '0px 8px', background: 'transparent', border: 'none', }}
          link={`/accounting/bill/view/${parentType}/${parentId}/${data[row.index].id}${showOrderNo? '?DO=true': ''}`} label={<ViewIcon />}
          goToAlreadyOpenPage />
      }
      <WhiteButton style={{ padding: '0px 8px', background: isView ? 'transparent' : undefined, border: isView ? 'none' : undefined }} size="regular" onClick={() => { print(data[row.index].id) }}>
        {data[row.index].draft ? <PrintIconDisabled /> : <PrintIcon />}
      </WhiteButton>
    </div>
  );
}


function InvoiceActionRenderer(
  parentId: number,
  parentType: ParentType,
  data: InvoHd[],   //any,
  row:any,
  isView:boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  previewReport : (x: Preportargs) => void,
    ) {
  const cannotOpen = (x: ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/edit/${parentType}`)
    )
  );
  const systemSettings = useSystemSettings();

  function print(invId: number, invNo:string) {
    if (data[row.index].draft) return;

    // window.open('http://cloud.suntekscm.co.kr/reports', '_blank')!.focus();
    //viewReport('bill');
    // ModPrintEntry.previewInvoice(viewReport, `Invoice [${invNo}]`, 'T_INVOHD', invId.toString(), 
    // systemSettings.userId??'');
    
    const reqParam: Preportargs = {
      docType: DocumentType.Invoice,
      subj:  `Invoice [${invNo}]`, 
      tbName: 'T_INVOHD',
      tbIds:  invId.toString(),
      userID:  systemSettings.userId??'',
    };

    previewReport(reqParam);
  }
  return (
    <div style={{ height: '25px', paddingTop: '2px', display: 'flex' }}>
      {!isView &&
        <UniqueLinkButton name={`invoice-edit-button-${row.index}`} display="white" size="regular" style={{ padding: '0px 8px' }}
          link={`/accounting/invoice/edit/${parentType}/${parentId}/${data[row.index].id}`}  label={<EditIcon />}
          uniqueLinkPrefixQuery={cannotOpen} beforeRedirect={() => beforeBillInvoiceCrdbOpen('invoice', 'edit')} 
          goToAlreadyOpenPage />
      }
      {isView &&
        <UniqueLinkButton name={`invoice-view-button-${row.index}`} display="white" size="regular" style={{ background: 'transparent', border: 'none', padding: '0px 8px' }}
          link={`/accounting/invoice/view/${parentType}/${parentId}/${data[row.index].id}`} label={<ViewIcon />}
          goToAlreadyOpenPage />
      }
      <WhiteButton name={`invoice-print-button-${row.index}`} style={{ padding: '0px 8px', background: isView ? 'transparent' : undefined, border: isView ? 'none' : undefined, }} size="regular" onClick={() => { print(data[row.index].id, data[row.index].invoiceNo) }}>
        {data[row.index].draft ? <PrintIconDisabled /> : <PrintIcon />}
      </WhiteButton>

    </div>
  );
}

function CrdbActionRenderer(
  parentId: number,
  parentType: ParentType,
  data:any,
  row:any,
  isView:boolean,
  previewReport : (x: Preportargs) => void,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
) {
  const cannotOpen = (x:ScreenStackItem) => data[row.index].fromRelatedEntity || isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/bill/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/edit/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/add/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/edit/${parentType}`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType.substring(0,2)}`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit/${parentType.substring(0,2)}`)
    )
  );

  const mhType = isHouseJob(parentType) ? 'H' : 'M';
  // const PrintButton = data[row.index].fromRelatedEntity ? LightBlueButton : WhiteButton;
  const PrintButton = IfmsButton;
  let baseClass = 'ifms-white-button';
  if (row.original.mhType && row.original.mhType !== mhType) baseClass = 'ifms-lightgreen-button'
  if (data[row.index].fromRelatedEntity) baseClass = 'ifms-lightblue-button'

  const opType = getJobNameByTbName(data[row.index].tbName);
  const opId = data[row.index].tbId;

  function print(id: number) {
    if (data[row.index].draft) return;

    const reqParam: Preportargs = {
      docType: DocumentType.CRDB,
      subj: `[CrDb #: ${data[row.index].crDbNo}]`,
      tbName: 'T_CRDBHD',
      tbIds: data[row.index].crDbId.toString(),
      userID: data[row.index].agentName,
    };

    previewReport(reqParam);
  }

  return (
    <div style={{ height: '25px', paddingTop: '2px', display: 'flex' }}>
      {(!isView && !data[row.index].fromRelatedEntity) &&
        // <UniqueLinkButton display="white" size="small" style={{width: '100%'}} 
        <UniqueLinkButton name={`crdb-edit-button-${row.index}`} baseClass={baseClass} size="regular" style={{ padding: '0px 8px' }}
          //[save-sqlinfo]link={`/accounting/crdb/edit/${parentType}/${parentId}/${data[row.index].id}`} 
          link={`/accounting/crdb/edit/${opType}/${opId}/${data[row.index].crDbId}`}
          label={<EditIcon />} uniqueLinkPrefixQuery={cannotOpen} beforeRedirect={() => beforeBillInvoiceCrdbOpen('crdb', 'edit')} 
          goToAlreadyOpenPage />
      }
      {(isView || data[row.index].fromRelatedEntity) &&
        // <UniqueLinkButton display={data[row.index].fromRelatedEntity ? 'lightblue' : 'white'} 
        <UniqueLinkButton name={`crdb-view-button-${row.index}`} baseClass={baseClass}
          size="regular" style={{ padding: '0px 8px', background: isView ? 'transparent' : undefined, border: isView ? 'none' : undefined }}
          //[save-sqlinfo]link={`/accounting/crdb/view/${parentType}/${parentId}/${data[row.index].id}`} 
          link={`/accounting/crdb/view/${opType}/${opId}/${data[row.index].crDbId}`}
          label={<ViewIcon />}
          goToAlreadyOpenPage />
      }
      <PrintButton baseClass={baseClass} style={{ padding: '0px 8px', background: isView ? 'transparent' : undefined, border: isView ? 'none' : undefined }} size="regular" onClick={() => { print(data[row.index].crDbId) }}>
        {data[row.index].draft ? <PrintIconDisabled /> : <PrintIcon />}
      </PrintButton>
    </div>
  );
}

function CurrencyRenderer(cellValue: any, currency: any, showZero: boolean = false) {
  let amount = '';
  const decimals = getDecimal(currency);
  if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
    const format = `0,0.${'0'.repeat(decimals)}`;
    amount = numeral(cellValue).format(format);
  }
  return (
    <div className="ifms-table-align-right">{parseFloat(amount) === 0 && !showZero ? null : amount}</div>
  );
}

// function CurrencyRenderer(cell:any, dataAccessor:any, currencyAccessor:any) {
  
//   const value = dataAccessor(cell);
//   const currency = currencyAccessor(cell);

//   return (
//     <div style={{height: '100%', width: '100%'}}>
//       <div style={{paddingTop: '7px', paddingRight: '5px', textAlign: 'right'}} data-tooltip="-from-value" data-tooltip-onlywhencutoff>
//         <CurrencyLabel currency={currency} value={value} />
//       </div>
//     </div>
//   );
// }

function RelatedCrdbNosRenderer(entity:any) {
  const relatedCrdbNos = //[save-sqlinfo]entity.relatedCrdbNos;
    entity.crDbNo;

  //[save-sqlinfo]const hasPending = entity.lineItems && entity.lineItems.some((l:any) => l && l.agent && l.agent.id > 0 && l.agentAmount && l.agentAmount > 0 && !l.relatedCrdbNo);

  return (
    <div className="ifms-table-align-left">
      {//[save-sqlinfo]!!hasPending &&
        relatedCrdbNos === 'Pending' &&
        <><span style={{ color: 'red' }}>Pending</span>&nbsp;</>
      }
      {relatedCrdbNos === 'Pending' ? '' : relatedCrdbNos}
    </div>
  );
}

function TextRenderer(cell:any, dataAccessor:any) {
  const value = dataAccessor(cell);

  return (
    <div className="ifms-table-default">
        {value}
    </div>
  );
}

function TextLeftRenderer(cell:any, dataAccessor:any) {
  const value = dataAccessor(cell);

  return (
    <div className="ifms-table-align-left">
        {value}
    </div>
  );
}

function CrdbNoRenderer(cell:any, dataAccessor:any, isPendingAccessor: any) {
  const isPending = isPendingAccessor(cell);
  const value = isPending ? 'Pending' : dataAccessor(cell);
  const fontStyle = isPending? {color : 'red'} : undefined;

  return (
    <div className="ifms-table-align-left" style={fontStyle}>
        {value}
    </div>
  );
}

function DateRenderer(cell:any, dataAccessor:any) {
  const value = dataAccessor(cell);

  return (
    <div className="ifms-table-default">
        {formatDate(value)}
    </div>
  );
}

function CheckboxIconRenderer(cell:any, dataAccessor:any) {
  const value = dataAccessor(cell);

  return (
    <div style={{height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <div style={{paddingTop: '1px'}}>
        {value &&
          <CheckBoxIcon value={value} />
        }
      </div>
    </div>
  );
}

function PaidRenderer(cell:any, dateAccessor:any, balAccessor:any, PaidAccessor:any) {
  const paidDate = dateAccessor(cell);
  const balAmount = balAccessor(cell);
  const PaidAmount = PaidAccessor(cell);

  const value = PaidAmount === 0 ? 'N' : (balAmount === PaidAmount ? 'Y' : 'P') 
  return (
    <div  className="ifms-table-default" data-tooltip={formatDate(paidDate ?? '')}>
    {value}
  </div>
  );
}

// function UnfoldRenderer({value, data, row}:any) {
//   const toggle = data[0].toggle;

//   return (
//     <div style={{marginLeft: '2px', marginTop: '2px', textAlign: 'left', cursor: 'pointer'}} onClick={() => toggle(row.index)}>
//       {value &&
//         <FoldIcon />
//       }
//       {!value &&
//         <UnfoldIcon />
//       }
//     </div>
//   );
// }

function BillAccordion({
  parentId,
  parentType,
  lineItems,
  tableStorage,
  isView,
  height,
  systemSettings,
  beforeBillInvoiceCrdbOpen,
  setSelectedPopupMenuItem,
  hideCrdb = false,
  showOrderNo = false,
}: {
  parentId: number,
  parentType: ParentType,
  lineItems: Array<ApHd>,    //[save-sqlinfo]Array<Bill>,
  tableStorage: TableStorage,
  isView: boolean,
  height: string,
  systemSettings: SystemSettings,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  setSelectedPopupMenuItem: (x:ActionButtonItem | null) => void,
  hideCrdb?: boolean,
  showOrderNo?: boolean,
}) {
  const [unfoldItems, setUnfoldItems] = useState<Array<number>>([]);

  function toggle(i: number) {
    const items = [...unfoldItems];
    const index = items.findIndex(x => x === i);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push(i);
    }

    setUnfoldItems(items);
  }

  const data = lineItems.map((x: any, i: number) => ({
    ...x,
    unfold: unfoldItems.includes(i),
    toggle,
  }));

  const tableOptions:ApplicableTableSettings = {
    tableName: 'billInsideAccordionLineItems',
    ...billInsideAccordionLineItems,
    height,
    data,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({data, row}:any) => BillActionRenderer(parentId, parentType, data, row, isView,beforeBillInvoiceCrdbOpen, setSelectedPopupMenuItem ) },
      { accessor: 'billNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billNo) },
      { accessor: 'billDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.billDate) },
      //[save-sqlinfo]{ accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void) },
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void > 0) },
      //[save-sqlinfo]{ accessor: 'vendorCost', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.vendorCost ? x.vendorCost.shortName : '') },
      { accessor: 'vendorName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.vendorName ?? '') },
      { accessor: 'billReceived', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.billReceived) },
      { accessor: 'dueDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.dueDate) },
      { accessor: 'paid', Cell: ({cell}:any) => PaidRenderer(cell.row.original, (x:any) => x.lastPaidDate, (x:any) => x.billAmt, (x:any) => x.paidAmt) },
      { accessor: 'hold', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.hold) },
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft) },
      //[save-sqlinfo]{ accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur) },
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency) },
      //<save-sqlinfo:
      // { accessor: 'billAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.billAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedCrdbNos', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      { accessor: 'billAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.billAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balanceDue', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balanceDue, cell.row.original.currency, true) },
      { accessor: 'crDbNo', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      // { accessor: 'unfold', Cell: UnfoldRenderer },
      //save-sqlinfo]
    ],
    customStorage: tableStorage,
    rowProps: (row: any) => {
      const unfold = unfoldItems.includes(row.index);

      const extrasTableOptions:ApplicableTableSettings = {
        tableName: 'billOrInvoicePreviewLineItems',
        //...billOrInvoicePreviewLineItems,
        ...billPreviewLineItems,
        data: [{
          billingCode: 'test', itemDescription: 'test', cur: 'USD', rate: '1000.000', qty: '1.000', amount: '1000.000', headerAmount: '1000.000', agent: 'Test'
        }],
        rowRenderers: [
          { accessor: 'billingCode', Cell: IndicatorRenderer },
          //save-sqlinfo]
        ],
      };

      return {
        rowextras: <div className={unfold ? 'ifms-unfold ifms-fold' : 'ifms-fold'} style={{width: '100%', paddingLeft: '80px'}}>
          <SmartTable {...extrasTableOptions} />
        </div>,
        style: {
          backgroundColor: isView ? '#F5F5F5' : 'white',
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    },
  };
  
  const tableOptions_noCrDb:ApplicableTableSettings = {
    tableName: 'billInsideAccordionLineItems_noCrDb',
    ...billInsideAccordionLineItems_noCrDb,
    height,
    data,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({data, row}:any) => BillActionRenderer(parentId, parentType, data, row, isView,beforeBillInvoiceCrdbOpen, setSelectedPopupMenuItem ) },
      { accessor: 'billNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billNo) },
      { accessor: 'billDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.billDate) },
      //[save-sqlinfo]{ accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void) },
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void > 0) },
      //[save-sqlinfo]{ accessor: 'vendorCost', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.vendorCost ? x.vendorCost.shortName : '') },
      { accessor: 'orderNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.orderNo) },
      { accessor: 'vendorName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.vendorName ?? '') },
      { accessor: 'ccName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.ccName ?? '') },
      { accessor: 'billReceived', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.billReceived) },
      { accessor: 'dueDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.dueDate) },
      { accessor: 'lastPaidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.lastPaidDate) },
      { accessor: 'hold', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.hold) },
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft) },
      //[save-sqlinfo]{ accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur) },
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency) },
      //<save-sqlinfo:
      // { accessor: 'billAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.billAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedCrdbNos', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      { accessor: 'billAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.billAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balanceDue', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balanceDue, cell.row.original.currency, true) },
      // { accessor: 'crDbNo', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      // { accessor: 'unfold', Cell: UnfoldRenderer },
      //save-sqlinfo]
    ],
    customStorage: tableStorage,
    rowProps: (row: any) => {
      const unfold = unfoldItems.includes(row.index);

      const extrasTableOptions:ApplicableTableSettings = {
        tableName: 'billOrInvoicePreviewLineItems',
        //...billOrInvoicePreviewLineItems,
        ...billPreviewLineItems,
        data: [{
          billingCode: 'test', itemDescription: 'test', cur: 'USD', rate: '1000.000', qty: '1.000', amount: '1000.000', headerAmount: '1000.000', agent: 'Test'
        }],
        rowRenderers: [
          { accessor: 'billingCode', Cell: IndicatorRenderer },
          //save-sqlinfo]
        ],
      };

      return {
        rowextras: <div className={unfold ? 'ifms-unfold ifms-fold' : 'ifms-fold'} style={{width: '100%', paddingLeft: '80px'}}>
          <SmartTable {...extrasTableOptions} />
        </div>,
        style: {
          backgroundColor: isView ? '#F5F5F5' : 'white',
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    },
  };

  const tableOptions_noCrDbWithDo:ApplicableTableSettings = {
    tableName: 'billInsideAccordionLineItems_noCrDbWithDo',
    ...billInsideAccordionLineItems_noCrDbWithDo,
    height,
    data,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({data, row}:any) => BillActionRenderer(parentId, parentType, data, row, isView,beforeBillInvoiceCrdbOpen, setSelectedPopupMenuItem, showOrderNo ) },
      { accessor: 'billNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.billNo) },
      { accessor: 'billDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.billDate) },
      //[save-sqlinfo]{ accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void) },
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void > 0) },
      //[save-sqlinfo]{ accessor: 'vendorCost', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.vendorCost ? x.vendorCost.shortName : '') },
      { accessor: 'vendorName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.vendorName ?? '') },
      { accessor: 'ccName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.ccName ?? '') },
      { accessor: 'billReceived', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.billReceived) },
      { accessor: 'dueDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.dueDate) },
      { accessor: 'lastPaidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.lastPaidDate) },
      { accessor: 'hold', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.hold) },
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft) },
      //[save-sqlinfo]{ accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur) },
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency) },
      //<save-sqlinfo:
      // { accessor: 'billAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.billAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedCrdbNos', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      { accessor: 'billAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.billAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balanceDue', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balanceDue, cell.row.original.currency, true) },
      // { accessor: 'crDbNo', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      // { accessor: 'unfold', Cell: UnfoldRenderer },
      //save-sqlinfo]
    ],
    customStorage: tableStorage,
    rowProps: (row: any) => {
      const unfold = unfoldItems.includes(row.index);

      const extrasTableOptions:ApplicableTableSettings = {
        tableName: 'billOrInvoicePreviewLineItems',
        //...billOrInvoicePreviewLineItems,
        ...billPreviewLineItems,
        data: [{
          billingCode: 'test', itemDescription: 'test', cur: 'USD', rate: '1000.000', qty: '1.000', amount: '1000.000', headerAmount: '1000.000', agent: 'Test'
        }],
        rowRenderers: [
          { accessor: 'billingCode', Cell: IndicatorRenderer },
          //save-sqlinfo]
        ],
      };

      return {
        rowextras: <div className={unfold ? 'ifms-unfold ifms-fold' : 'ifms-fold'} style={{width: '100%', paddingLeft: '80px'}}>
          <SmartTable {...extrasTableOptions} />
        </div>,
        style: {
          backgroundColor: isView ? '#F5F5F5' : 'white',
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    },
  };


  return (
    <div>
      {hideCrdb ? 
        (showOrderNo ? <SmartTable {...tableOptions_noCrDbWithDo} /> : <SmartTable {...tableOptions_noCrDb} /> ) 
        :
        <SmartTable {...tableOptions} />
      }
    </div>
  );
}

function InvoiceAccordion({
  parentId,
  parentType,
  lineItems,
  tableStorage,
  isView,
  height,
  systemSettings,
  beforeBillInvoiceCrdbOpen,
  previewReport,
  hideCrdb = false,
}: {
  parentId: number,
  parentType: ParentType,
  lineItems: Array<InvoHd>,   //[save-sqlinfo] Array<Invoice>,
  tableStorage: TableStorage,
  isView: boolean,
  height: string,
  systemSettings: SystemSettings,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  previewReport : (x: Preportargs) => void,
  hideCrdb?: boolean,
  }) {
  const tableOptions:ApplicableTableSettings = {
    tableName: 'invoiceInsideAccordionLineItems',
    ...invoiceInsideAccordionLineItems,
    height,
    data: lineItems,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({ data, row }: any) => InvoiceActionRenderer(parentId, parentType, data, row, isView, beforeBillInvoiceCrdbOpen, previewReport) },
      { accessor: 'invoiceNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.invoiceNo) },
      //<save-sqlinfo:
      // { accessor: 'invoiceDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.invoiceDate) },
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void) },
      // { accessor: 'invoiceTo', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.invoiceTo ? x.invoiceTo.shortName : '') },
      // { accessor: 'xmt', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.xmt) },
      { accessor: 'postDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.postDate) },
      // { accessor: 'isVoid', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.isVoid > 0) },
      { accessor: 'invoiceToName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.invoiceToName ?? '') },
      { accessor: 'transmitted', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.transmitted) },
      //save-sqlinfo>
      { accessor: 'dueDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.dueDate) },
      //<save-sqlinfo:
      // { accessor: 'lastPaidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.lastPaidDate) },
      // { accessor: 'overdue', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.overdue) },
      { accessor: 'paid', Cell: ({cell}:any) => PaidRenderer(cell.row.original, (x:any) => x.paidDate, (x:any) => x.invoiceAmt, (x:any) => x.paidAmt) },
      { accessor: 'overdue', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => getDiffDays(now(), x.dueDate)) },
      //save-sqlinfo>
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft) },
      //<save-sql:
      // { accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur) },
      // { accessor: 'invoiceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.invoiceAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedCrdbNos', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency) },
      { accessor: 'invoiceAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.invoiceAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balanceAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balanceAmt, cell.row.original.currency, true) },
      { accessor: 'crDbNo', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      //save-sql>
    ],
    customStorage: tableStorage,
    rowProps: (row: any) => {
      return {
        style: {
          backgroundColor: isView ? '#F5F5F5' : 'white',
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    }
  };

  const tableOptions_noCrDb:ApplicableTableSettings = {
    tableName: 'invoiceInsideAccordionLineItems_noCrDb',
    ...invoiceInsideAccordionLineItems_noCrDb,
    height,
    data: lineItems,
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({ data, row }: any) => InvoiceActionRenderer(parentId, parentType, data, row, isView, beforeBillInvoiceCrdbOpen, previewReport) },
      { accessor: 'invoiceNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.invoiceNo) },
      //<save-sqlinfo:
      // { accessor: 'invoiceDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.invoiceDate) },
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void) },
      // { accessor: 'invoiceTo', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.invoiceTo ? x.invoiceTo.shortName : '') },
      // { accessor: 'xmt', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.xmt) },
      { accessor: 'postDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.postDate) },
      // { accessor: 'isVoid', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.isVoid > 0) },
      { accessor: 'invoiceToName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.invoiceToName ?? '') },
      { accessor: 'transmitted', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.transmitted) },
      //save-sqlinfo>
      { accessor: 'dueDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.dueDate) },
      //<save-sqlinfo:
      // { accessor: 'lastPaidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.lastPaidDate) },
      // { accessor: 'overdue', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.overdue) },
      { accessor: 'paidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.paidDate) },
      { accessor: 'overdue', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => getDiffDays(now(), x.dueDate)) },
      //save-sqlinfo>
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft) },
      //<save-sql:
      // { accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur) },
      // { accessor: 'invoiceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.invoiceAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedCrdbNos', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency) },
      { accessor: 'invoiceAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.invoiceAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balanceAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balanceAmt, cell.row.original.currency, true) },
      // { accessor: 'crDbNo', Cell: ({cell}:any) => RelatedCrdbNosRenderer(cell.row.original)},
      //save-sql>
    ],
    customStorage: tableStorage,
    rowProps: (row: any) => {
      return {
        style: {
          backgroundColor: isView ? '#F5F5F5' : 'white',
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    }
  };

  return (
    <div>
      {hideCrdb ?
        <SmartTable {...tableOptions_noCrDb} />
        :
        <SmartTable {...tableOptions} />
      }
    </div>
  );
}

function CrDbAccordion({
  parentId,
  parentType,
  lineItems,
  tableStorage,
  height,
  isView,
  previewReport,
  beforeBillInvoiceCrdbOpen
}: {
  parentId: number,
  parentType: ParentType,
  lineItems: Array<SalesCostCrDb>,   //[save-sqlinfo] Array<Crdb>,
  tableStorage: TableStorage,
  isView: boolean,
  height: string,
  previewReport : (x: Preportargs) => void,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  }) {
    let colName = 'B/L #'
    if(parentType === JobNames.OtherOP) colName = 'Ref #';
    else if(parentType === JobNames.WHRcv) colName = 'Receiving ID';
    else if(parentType === JobNames.WHShip) colName = 'Shipping ID';

  const tableOptions: ApplicableTableSettings = {
    tableName: 'crdbInsideAccordionLineItems',
    ...crdbInsideAccordionLineItems,
    height,
    data: lineItems.map(x => ({
      ...x, 
    })),
    rowRenderers: [
      { accessor: 'indicator', Cell: IndicatorRenderer },
      { accessor: 'action', Cell: ({ data, row }: any) => CrdbActionRenderer(parentId, parentType, data, row, isView, previewReport, beforeBillInvoiceCrdbOpen) },
      //<save-sqlinfo:
      // { accessor: 'crdbNo', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.crdbNo) },
      // { accessor: 'crdbDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.crdbDate) },
      { accessor: 'crDbNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.crDbNo) },
      { accessor: 'crDbDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.crDbDate) },
      //save-sqlinfo>
      // { accessor: 'void', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.void > 0) },
      //<save-sqlinfo:
      // { accessor: 'agent', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.agent ? x.agent.shortName : '') },
      // { accessor: 'cfm', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.cfm) },
      { accessor: 'agentName', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.agentName ?? '') },
      { accessor: 'printed', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.printed === '1' ) },
      { accessor: 'isConfirm', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.isConfirm) },
      //save-sqlinfo>
      { accessor: 'draft', Cell: ({cell}:any) => CheckboxIconRenderer(cell.row.original, (x:any) => x.draft)},
      //<save-sqlifo:
      // { accessor: 'cur', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.cur)},
      // { accessor: 'lastPaidDate', Cell: ({cell}:any) => DateRenderer(cell.row.original, (x:any) => x.lastPaidDate) },
      // { accessor: 'debitAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.debitAmount, (x:any) => x.cur) },
      // { accessor: 'creditAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.creditAmount, (x:any) => x.cur) },
      // { accessor: 'crdbAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.crdbAmount, (x:any) => x.cur) },
      // { accessor: 'paidAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.paidAmount, (x:any) => x.cur) },
      // { accessor: 'balanceAmount', Cell: ({cell}:any) => CurrencyRenderer(cell.row.original, (x:any) => x.balanceAmount, (x:any) => x.cur) },
      // { accessor: 'relatedBlNo', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.relatedBlNo) },
      { accessor: 'currency', Cell: ({cell}:any) => TextRenderer(cell.row.original, (x:any) => x.currency)},
      { accessor: 'paid', Cell: ({cell}:any) => PaidRenderer(cell.row.original, (x:any) => x.paidDate, (x:any) => x.totalAmt, (x:any) => x.paidAmt) },
      { accessor: 'debitAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.debitAmt, cell.row.original.currency, true) },
      { accessor: 'creditAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.creditAmt, cell.row.original.currency, true) },
      { accessor: 'totalAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.totalAmt, cell.row.original.currency, true) },
      { accessor: 'paidAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.paidAmt, cell.row.original.currency, true) },
      { accessor: 'balAmt', Cell: ({ cell }: any) => CurrencyRenderer(cell.row.original.balAmt, cell.row.original.currency, true) },
      { accessor: 'blNo', Cell: ({cell}:any) => TextLeftRenderer(cell.row.original, (x:any) => x.blNo), Header: () => colName},
      //sql-info>
    ],
    rowProps: (row:any) => {
      const mhType = isHouseJob(parentType) ? 'H' : 'M';
      let backColor = isView ? '#F5F5F5' : 'white';
      if (row.original.mhType && row.original.mhType !== mhType) backColor = '#c0ffc0';
      if (row.original.fromRelatedEntity) backColor = HighlightColor;

      return {
        style: {
          // backgroundColor: row.original.fromRelatedEntity ? HighlightColor : (isView ? '#d9d9d9' : 'white'),
          backgroundColor: backColor,
          borderBottom: isView ? '1px solid #E5E5E5' : undefined,
        }
      };
    },
    customStorage: tableStorage,
  };

  return (
    <SmartTable {...tableOptions} />
  );
}

const BicSectionStyle = {
  marginTop: '30px',
};

function NewBill({
  beforeBillInvoiceCrdbOpen,
  parentId,
  parentType,
  isView,
  isConnectDo = false,
}: {
  isView: boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  parentId: number,
  parentType: ParentType,
  isConnectDo?: boolean,
}) {
  async function beforeBillNewOpen() {
    const saved = await beforeBillInvoiceCrdbOpen('bill', 'add');
    if (!saved) {
      return false;
    }

    return true;
  }

  // const cannotOpen = (x:ScreenStackItem) => isView || (
  //   !!x && !!x.url && (
  //     x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/crdb/edit/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/bill/add/${parentType}`)
  //   )
  // );
  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/add`)
    )
  );

  const label = <><FontAwesomeIcon icon={faPlus} />&nbsp;New Bill</>

  return (
    <div>
      <UniqueLinkButton name='sales-const-entry-newBill-button' size="small" style={{height: '20px', width: '110px'}} link={`/accounting/bill/add/${parentType}/${parentId}${isConnectDo? '?DO=true':''}`} label={label} beforeRedirect={beforeBillNewOpen} uniqueLinkPrefixQuery={cannotOpen} />
    </div>
  );
}

function NewBillFromCopy({
  beforeBillInvoiceCrdbOpen,
  parentId,
  parentType,
  isView,
  setSelectedPopupMenuItem,
  isOtherJob = false,
}: {
  isView: boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  parentId: number,
  parentType: ParentType,
  setSelectedPopupMenuItem: (x:ActionButtonItem | null) => void,
  isOtherJob?: boolean,
}) {
  async function beforeBillNewOpen() {
    const onPopupClose = () => {
      setSelectedPopupMenuItem(null);
    }

    const saved = await beforeBillInvoiceCrdbOpen('bill', 'add');
    if (!saved) {
      return false;
    }
    
    setSelectedPopupMenuItem({
      label:'Select a target Bill to be linked',
      popupWidth: 450,
      popupComponent:
        <CopyInvoice
          jobId={0}
          jobName={JobNames.Bill}
          srcJobName={parentType}
          srcJobId={parentId}
          onPopupClose={onPopupClose}
          isFromCopy={true}
          isOtherJob={isOtherJob}
        />
    });
    return false;
  }

  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/add`)
    )
  );

  const label = <><FontAwesomeIcon icon={faPlus} />&nbsp;Copy From</>

  return (
    <div>
      <UniqueLinkButton name='sales-const-entry-newBill-copy-button' size="small" style={{height: '20px', width: '110px'}} link={`/accounting/bill/add/${parentType}/${parentId}`} label={label} beforeRedirect={beforeBillNewOpen} uniqueLinkPrefixQuery={cannotOpen} />
    </div>
  );
}

function NewInvoice({
  beforeBillInvoiceCrdbOpen,
  parentId,
  parentType,
  isView,
}:{
  isView: boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  parentId: number,
  parentType: ParentType,
}) {
  async function beforeInvoiceNewOpen() {
    const saved = await beforeBillInvoiceCrdbOpen('invoice', 'add');
    if (!saved) {
      return false;
    }

    return true;
  }

  // const cannotOpen = (x:ScreenStackItem) => isView || (
  //   !!x && !!x.url && (
  //     x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/crdb/edit/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/invoice/add/${parentType}`)
  //   )
  // );

  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/add`)
    )
  );

  const label = <><FontAwesomeIcon icon={faPlus} />&nbsp;New Invoice</>

  return (
    <div>
      <UniqueLinkButton name='sales-const-entry-newInvoice-button' size="small" style={{height: '20px', width: '110px'}} link={`/accounting/invoice/add/${parentType}/${parentId}`} label={label} beforeRedirect={beforeInvoiceNewOpen} uniqueLinkPrefixQuery={cannotOpen} />
    </div>
  );
}


function NewInvoiceFromCopy({
  beforeBillInvoiceCrdbOpen,
  parentId,
  parentType,
  isView,
  setSelectedPopupMenuItem
}: {
  isView: boolean,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  parentId: number,
  parentType: ParentType,
  setSelectedPopupMenuItem: (x:ActionButtonItem | null) => void
}) {
  async function beforeBillNewOpen() {
    const onPopupClose = () => {
      setSelectedPopupMenuItem(null);
    }

    const saved = await beforeBillInvoiceCrdbOpen('invoice', 'add');
    if (!saved) {
      return false;
    }
    
    setSelectedPopupMenuItem({
      label:'Select a target Invoice to be linked',
      popupWidth: 450,
      popupComponent:
        <CopyInvoice
          jobId={0}
          jobName={JobNames.Invoice}
          srcJobName={parentType}
          srcJobId={parentId}
          onPopupClose={onPopupClose}
          isFromCopy={true}
        />
    });
    return false;
  }

  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/crdb/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/add`)
    )
  );

  const label = <><FontAwesomeIcon icon={faPlus} />&nbsp;Copy From</>

  return (
    <div>
      <UniqueLinkButton name='sales-const-entry-newInvoice-copy-button' size="small" style={{height: '20px', width: '110px'}} link={`/accounting/invoice/add/${parentType}/${parentId}`} label={label} beforeRedirect={beforeBillNewOpen} uniqueLinkPrefixQuery={cannotOpen} />
    </div>
  );
}


function NewCrDb({
  parentId,
  parentType,
  beforeBillInvoiceCrdbOpen,
  isView,
  agents,
  agentCur,
  cur,
  pendingItems,
  summary,
  setShowCrdbSummary,
}: {
  isView: boolean,
  parentId: number,
  parentType: ParentType,
  beforeBillInvoiceCrdbOpen: (x:string, y:string) => Promise<boolean>,
  pendingItems: Array<SalesCostPendingItem>,
  agents: Array<number>,
  agentCur: Array<string>,
  cur: Array<string>,
  summary: SalesCostSummary,
  setShowCrdbSummary: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const hasRelatedCrdb = agentCur && agentCur.length > 0;

  const [selectedRelatedCrdb, setSelectedRelatedCrdb] = useState(hasRelatedCrdb ? 1 : 0);

  useEffect(() => {
    if (hasRelatedCrdb && selectedRelatedCrdb <=0) {
      setSelectedRelatedCrdb(1);
    }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [agentCur]
  );

  async function beforeCrdbNewOpen() {
    const saved = await beforeBillInvoiceCrdbOpen('crdb', 'add');
    if (!saved) {
      return false;
    }

    return true;
  }

  // const cannotOpen = (x:ScreenStackItem) => isView || (
  //   !!x && !!x.url && (
  //     x.url.toLowerCase().startsWith(`/accounting/bill/add/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/bill/edit/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/invoice/add/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/invoice/edit/${parentType}`) ||
  //     x.url.toLowerCase().startsWith(`/accounting/crdb/add/${parentType}`)
  //   )
  // );
  const cannotOpen = (x:ScreenStackItem) => isView || (
    !!x && !!x.url && (
      x.url.toLowerCase().startsWith(`/accounting/bill/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/bill/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/add`) ||
      x.url.toLowerCase().startsWith(`/accounting/invoice/edit`) ||
      x.url.toLowerCase().startsWith(`/accounting/crdb/add`)
    )
  );

  const label = <><FontAwesomeIcon icon={faPlus} />&nbsp;New CrDb Note</>

  let newLink = `/accounting/crdb/add/${parentType}/${parentId}`;
  if (hasRelatedCrdb && selectedRelatedCrdb > 0) {
    newLink = `${newLink}?agentCur=${cur[selectedRelatedCrdb - 1]}&agentId=${agents[selectedRelatedCrdb - 1]}`;
  }

  return (
    <div style={{ display:'flex', width: '100%'}}>
      <div style={{ float: 'left' }}>
        <UniqueLinkButton name='sales-const-entry-newCrDb-button' style={{height: '20px'}} link={newLink} label={label} beforeRedirect={beforeCrdbNewOpen} uniqueLinkPrefixQuery={cannotOpen} />
      </div>
      {/* <PrimaryButton onClick={() => setShowCrdbSummary(true)} disabled={!summary || !summary.crdbSummary || summary.crdbSummary.length <= 0} size="small" style={{height: '20px', width: '80px', marginLeft: '8px'}}>Overall</PrimaryButton> */}
      <div id='crdb-pending' style={{ width: '350px', marginLeft: '60px', float: 'left'}}>
        {hasRelatedCrdb && pendingItems.length > 0 &&
          <LabeledSelect
            red
            bold
            label="** CrDb Pending **"
            labelSize="220px"
            items={(agentCur ?? []).map((x, i) => ({
              value: i + 1,
              label: x
            }))}
            value={selectedRelatedCrdb}
            onChange={e => setSelectedRelatedCrdb(parseInt(e.target.value))}
            disabled={isView}
          />
        }
      </div>
      <div className="clearfix"></div>
    </div>
  );
}

/*function pixelStringToNum(s: string):number {
  const withoutSuffix = s.substring(0, s.length - 2);
  const result = parseInt(withoutSuffix);

  window.console.log(result);

  return result;
}*/

function SalesCostEntry({
  parentId,
  beforeBillInvoiceCrdbOpen,
  isView,
  parentType,
  readonlyCrdbLineItems = [],
  profitShare,
  setProfitShare,
  invoiceBill,
  setInvoiceBill,
  setUsedAgent,
  acctClose,
  operClose,
  parentInitialized,
  hideCrdb = false,
  hideInvoice = false,
  parentData = null,
  selectedIndex,
  setSelectedIndex,
}: {
  parentId: number,
  beforeBillInvoiceCrdbOpen: (x:string) => Promise<boolean>,
  isView: boolean,
  parentType:ParentType,
  readonlyCrdbLineItems?: Array<SalesCostCrDb>,
  profitShare: number,
  setProfitShare: (p:number) => void,
  invoiceBill:InvoiceBillCrdb|null,
  setInvoiceBill: (x:InvoiceBillCrdb|null) => void,
  setUsedAgent?: (agent2: number, agent2Name: string, agent3: number, agent3Name: string) => void,
  acctClose: boolean,
  operClose: boolean,
  parentInitialized:boolean,
  hideCrdb?: boolean,
  hideInvoice?: boolean,
  parentData?: any,
  selectedIndex?:number,
  setSelectedIndex?: (p: number) => void,
}) {
  const tableStorage = useTableStorage();
  const systemSettings = useSystemSettings();

  //const [openedBicElements, setOpenedBicElements] = useState<Array<number>>([]);
  const [pendingItems, setPendingItems] = useState<Array<SalesCostPendingItem>>([]);
  const [agentCur, setAgentCur] = useState<Array<string>>([]);
  const [agents, setAgents] = useState<Array<number>>([]);
  const [cur, setCur] = useState<Array<string>>([]);
  const [summary, setSummary] = useState<SalesCostSummary>({
    billSummary: [],
    invoiceSummary: [],
    crdbSummary: [],
  });

  const [showBillSummary, setShowBillSummary] = useState(false);  
  const [showBillingOverall, setShowBillingOverall] = useState(false);
  const [showInvoiceSummary, setShowInvoiceSummary] = useState(false);
  const [showCrdbSummary, setShowCrdbSummary] = useState(false);

  // const isBillOpened = openedBicElements.includes(0);
  // const isInvoiceOpened = openedBicElements.includes(1);
  // const isCrdbOpened = openedBicElements.includes(2);

  const fmsGlobal = getFmsGlobal();
  const opBlockAfterClose = fmsGlobal?.OPAcctBlockAfterClosed??false;
  const { viewReport } = useReportViewer();
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function PreviewReport(params : Preportargs) {    
    switch(params.docType) {
      case DocumentType.Invoice:
        let tbId = params.tbIds.startsWith('R') ? params.tbIds.substring(1).split(','): params.tbIds.split(',');
        let toCompanyid = `${await appContext.api.getRList(tbId[0], params.tbName, "F_BillTo")}`;
       viewReport(new InvoiceArgs({
          docType: DocumentType.Invoice,
          formCaption:  params.subj,
          subject: params.subj,
          stamp: appContext.suntekSettings?.accounting?.showPastDueOnInv,
          useMultiCur: appContext.suntekSettings?.accounting?.showCurAmountInInv, 
          //toCompanyid: 'R',    // Use GetMaterBranch/GetRList of tbId[0]
          toCompanyid: toCompanyid ,
          tbName : params.tbName,
          tbId: params.tbIds,
          userID : params.userID
        }), '', true);
        break;
      case DocumentType.CRDB:
        viewReport(new CRDBArgs({
          docType: DocumentType.CRDB,
          formCaption: `Cr/Db Note ${params.subj}`,
          subject: `Cr/Db Note ${params.subj}`,
          toCompanyid: params.userID,
          tbName: 'T_CRDBHD',
          tbId: params.tbIds
        }), '', true);
        break;
    }
  }

  /*
  function toggleBicElement(index:number) {
    const elementIndex = openedBicElements.findIndex(x => x === index);

    if (elementIndex >= 0) {
      setOpenedBicElements([]);
    } else {
      setOpenedBicElements([index]);
    }
  }
*/
  const bicElementSingleHeight = 158;

  let billHeight = `${bicElementSingleHeight}px`;
  let invoiceHeight = `${bicElementSingleHeight}px`;
  let crdbHeight = `${bicElementSingleHeight}px`;

  // if (openedBicElements.length > 0) {
  //   billHeight = isBillOpened ? `${bicElementSingleHeight * 2 + 2}px` : `${bicElementSingleHeight}px`;
  //   invoiceHeight = isInvoiceOpened ? `272px` : '0px';
  //   crdbHeight = isCrdbOpened ? `272px` : isInvoiceOpened ? '0px' : `125px`;
  // }

  //<save-sqlinfo:
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  async function initialize() {
    initializeSalesCostData();
    initializePendingItems();
    initializeDetails();
    initializeUsedAgents();
  }
  async function initializeSalesCostData() {
    const apiResult = await appContext.api.getJobSalesCost(parentType, parentType === JobNames.BTDo ? parentData.id  : parentId);
    
    if(apiResult === null) {
      await showGlobalOkDialog(<p>Cannot load invoice, bill and CrDb information</p>);
      return;
    }

    //<pt220304: clear readOnlyCrdbLineitems. Move SalesCostCrDb which is not belong to parentType
    if(readonlyCrdbLineItems.length > 0) readonlyCrdbLineItems.splice(0);
    // Type에 상관없이 Master, House 모두 표시
    // if([JobNames.OtherOP, JobNames.WHShip, JobNames.WHRcv].indexOf(parentType) < 0) {
    //   const mhType = isHouseJob(parentType) ? 'H' : 'M';
    //   readonlyCrdbLineItems.push(..._.remove(apiResult.crdbLineItems, (x:SalesCostCrDb) => x.mhType !== mhType));
    // }
    //pt220304>

    const newInvoiceBill: InvoiceBillCrdb = {
      ...apiResult,
      isShipmentTypeLock: shouldLockShipmentTypeField(apiResult),
    };

    setInvoiceBill(newInvoiceBill);
  }

  async function initializePendingItems() {
    if (parentId <= 0) {
      return; // New
    }
    const apiResult = await appContext.api.getJobSalesCostPendingItems(parentType, parentId); // as Array<SalesCostPendingItem>;
    //if (apiResult) {
    //  setPendingItems(apiResult);
    //  setAgentCur(_.uniq(apiResult.map(x => x.agentCur)));
    //}
    if (apiResult && apiResult.success) {
      setPendingItems(apiResult.result);
      const result = apiResult.result as Array<SalesCostPendingItem>
      //setAgentCur(_.uniq(result.map(x => x.agentCur)));
      //setCur(_.uniq(result.map(x => x.cur)));
      //setAgents(_.uniq(result.map(x => x.agent)));

      let tmpAgentCur:Array<string> = [];
      let tmpCur:Array<string> = [];
      let tmpAgents:Array<number> = [];

      result.forEach(r => {
        if (tmpAgentCur.findIndex(f => f === r.agentCur) === -1) {
          tmpAgentCur.push(r.agentCur);
          tmpCur.push(r.cur);
          tmpAgents.push(r.agent);
        }
      });
      setAgentCur(tmpAgentCur);
      setCur(tmpCur);
      setAgents(tmpAgents);
    }
  }

  async function initializeDetails() {
    const apiResult = await appContext.api.getJobSalesCostSummary(parentType, parentId);
    //if (apiResult) {
    // setSummary(apiResult);
    //}

    if (apiResult && apiResult.success) {
      setSummary(apiResult.result);
    }
  }
  async function initializeUsedAgents() {
    if (parentId <= 0) {
      return; // New
    }

    if (setUsedAgent) {
      let agents = await GetOpUsedAgents(appContext, parentType, parentId);  
      setUsedAgent(agents.agent2, agents.agent2Name, agents.agent3, agents.agent3Name);
    }
  }
  
  useEffect(() => {
    // For now, let's refresh every time
    if(parentInitialized) initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentInitialized]);
  //save-sqlinfo>

  return (
    <div style={{width : '1140px'}}>
      {parentType === JobNames.BTDo && 
      <>
        <div style={{height:'30px'}}>
          <BlueTitleRow
            noLine
            title={`Manifest (${parentData?.loadOrderList?.length ?? 0})`}
            right={undefined}
          />
        </div>
        <div style={{display: 'flex', marginBottom: '30px'}}>
          <BTLocalDODetailInfo btDo={parentData} onChange={undefined} isView={true} tableName={'btLocalDODetailInfoView'} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex}/>
        </div>
        <div>
        <BlueTitleRow
          noLine
          //[save-sq;info]title={`Bill (${invoiceBill.billLineItems.length})`}
          title={`Bill (${invoiceBill?.billLineItems.length ?? 0})`}
          right={
            <div style={{display: 'flex'}}>
              <NewBill parentId={parentId} parentType={JobNames.BTOrder} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen} 
              isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose) } isConnectDo={true} 
               />
               <>&nbsp;&nbsp;
              <NewBillFromCopy parentId={parentId} parentType={JobNames.BTOrder} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen} setSelectedPopupMenuItem={setSelectedPopupMenuItem}
                isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose && operClose)} isOtherJob={true}/></>
              <PrimaryButton onClick={() => setShowBillSummary(true)} disabled={!summary || !summary.billSummary || summary.billSummary.length <= 0} size="small" style={{ height: '20px', width: '80px', marginLeft: '8px' }}>Overall</PrimaryButton>
              {/* <PrimaryButton style={{height: '20px', width: '20px', paddingLeft: '2px', paddingRight: '2px'}} size="small" onClick={() => toggleBicElement(0)}><FontAwesomeIcon style={{transform: 'rotate(-90deg)'}} icon={isBillOpened ? faForward : faBackward} /></PrimaryButton> */}
            </div>
          }
        />

        <div>
          <BillAccordion
            parentId={parentId}
            parentType={JobNames.BTOrder}
            //[save-sqlinfo]lineItems={invoiceBill.billLineItems}
            lineItems={invoiceBill?.billLineItems??[]}
            tableStorage={tableStorage}
            isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose)}
            systemSettings={systemSettings}
            height={billHeight}
            beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
            setSelectedPopupMenuItem={setSelectedPopupMenuItem}
            hideCrdb={hideCrdb}
            showOrderNo={true}
          />
        </div>
      </div>
      </>
      }
    {parentType !== JobNames.BTDo &&
      <div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <BlueTitleRow
            noLine
            //[save-sq;info]title={`Bill (${invoiceBill.billLineItems.length})`}
            title={`Bill (${invoiceBill?.billLineItems.length ?? 0})`}
            style={{ fontSize: '13px' }}
            right={
              <div style={{display: 'flex'}}>
                <NewBill parentId={parentId} parentType={parentType} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
                  isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose && operClose)}
                />
                {parentType !== JobNames.WHRcv && parentType !== JobNames.WHShip &&
                <>&nbsp;&nbsp;
                  <NewBillFromCopy parentId={parentId} parentType={parentType} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen} setSelectedPopupMenuItem={setSelectedPopupMenuItem}
                    isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose && operClose)} />
                </>}
                
                {/* <div style={{ margin: 'auto' }}></div> */}
                {/* <PrimaryButton onClick={() => setShowBillSummary(true)} disabled={!summary || !summary.billSummary || summary.billSummary.length <= 0} size="small" style={{ height: '20px', width: '80px', marginLeft: '8px' }}>Overall</PrimaryButton> */}
                {/* <PrimaryButton style={{height: '20px', width: '20px', paddingLeft: '2px', paddingRight: '2px'}} size="small" onClick={() => toggleBicElement(0)}><FontAwesomeIcon style={{transform: 'rotate(-90deg)'}} icon={isBillOpened ? faForward : faBackward} /></PrimaryButton> */}
              </div>
            }
          />
          <SecondaryButton
            hoverIcon={billingOverallInconWhite}
            icon={billingOverallIncon} disabledIcon={billingOverallInconGray} name='billing-overall-button' size="regular" notsetbackcolorwhenfocus='clear'
            onClick={() => setShowBillingOverall(true)} data-tooltip='Billing Overall' style={{ display: "flex", width: '23px', height: '23px', position: "relative", paddingLeft: '13px', paddingTop: '3px' }} >
          </SecondaryButton>
        </div>
        <div>
          <BillAccordion
            parentId={parentId}
            parentType={parentType}
            //[save-sqlinfo]lineItems={invoiceBill.billLineItems}
            lineItems={invoiceBill?.billLineItems??[]}
            tableStorage={tableStorage}
            isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose)}
            systemSettings={systemSettings}
            height={billHeight}
            beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
            setSelectedPopupMenuItem={setSelectedPopupMenuItem}
            hideCrdb={hideCrdb}
          />
        </div>
      </div>
    }

      {!hideInvoice &&     
      <div style={BicSectionStyle}>
        <BlueTitleRow
          noLine
          //[save-sqlinfo]title={`Invoice (${invoiceBill.invoiceLineItems.length})`}
          title={`Invoice (${invoiceBill?.invoiceLineItems.length ?? 0})`}
          style={{ fontSize: '13px' }}
          right={
            <div style={{ display: 'flex' }}>
              <NewInvoice parentId={parentId} parentType={parentType} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
                isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose && operClose)}
              />
              {parentType !== JobNames.WHRcv && parentType !== JobNames.WHShip && 
              <>&nbsp;&nbsp;
                <NewInvoiceFromCopy parentId={parentId} parentType={parentType} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen} setSelectedPopupMenuItem={setSelectedPopupMenuItem}
                  isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose && operClose)} />
              </>}
              {/* <div style={{ margin: 'auto' }}></div> */}
              {/* <PrimaryButton onClick={() => setShowInvoiceSummary(true)} disabled={!summary || !summary.invoiceSummary || summary.invoiceSummary.length <= 0} size="small" style={{ height: '20px', width: '80px', marginLeft: '8px' }}>Overall</PrimaryButton> */}
              {/* <PrimaryButton style={{height: '20px', width: '20px', paddingLeft: '2px', paddingRight: '2px'}} size="small" onClick={() => toggleBicElement(1)}><FontAwesomeIcon style={{transform: 'rotate(-90deg)'}} icon={isInvoiceOpened ? faForward : faBackward} /></PrimaryButton> */}
            </div>
          }
        />

        <div>
          <InvoiceAccordion
            parentId={parentId}
            parentType={parentType}
            //[save-sqlinfo]lineItems={invoiceBill.invoiceLineItems}
            lineItems={invoiceBill?.invoiceLineItems ?? []}
            tableStorage={tableStorage}
            isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose)}
            systemSettings={systemSettings}
            height={invoiceHeight}
            beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
            previewReport={PreviewReport}
            hideCrdb={hideCrdb}
                      />
        </div>
      </div>
      }
      {!hideCrdb &&
      <div style={BicSectionStyle}>
        <BlueTitleRow
          noLine
          //title={`CrDb (${invoiceBill.crdbLineItems.length})`}
          title={`CrDb (${invoiceBill?.crdbLineItems.length ?? 0})`}
          style={{ fontSize: '13px' }}
          right={
            <div style={{display: 'flex'}}>
              <NewCrDb parentId={parentId} parentType={parentType} beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen} 
              isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose)} 
              pendingItems={pendingItems} agentCur={agentCur} cur={cur} agents={agents} summary={summary} setShowCrdbSummary={setShowCrdbSummary} />
              <div style={{margin: 'auto'}}></div>
              {/* <div style={{width: '180px', marginRight: '20px', color: 'black', position: 'relative', top: '2px', visibility : (parentType === JobNames.WHShip || parentType === JobNames.WHRcv) ? 'hidden' : 'visible'}}> */}
              <div style={{width: '180px', marginRight: '20px', color: 'black', position: 'relative', top: '2px', visibility : 'hidden'}}>
                <LabeledFloat
                  label="Profit Share (%)"
                  labelSize="100px"
                  //[save-sqlinfo]value={invoiceBill.profitShare }
                  value={profitShare}
                  onChange={profitShare => setProfitShare(profitShare ?? 0)}
                  disabled={isView}
                  min={0}
                  max={9999.99}
                />
              </div>
              {/* <PrimaryButton onClick={() => setShowCrdbSummary(true)} disabled={!summary || !summary.crdbSummary || summary.crdbSummary.length <= 0} size="small" style={{height: '20px', width: '80px', marginRight: '40px'}}>Overall</PrimaryButton> */}
              {/* <PrimaryButton size="small" style={{height: '20px', width: '20px', paddingLeft: '2px', paddingRight: '2px'}} onClick={() => toggleBicElement(2)}><FontAwesomeIcon style={{transform: 'rotate(-90deg)'}} icon={isCrdbOpened ? faForward : faBackward} /></PrimaryButton> */}
            </div>
          }
        />

        <div>
          <CrDbAccordion
            parentId={parentId}
            parentType={parentType}
            lineItems={//[save-sqlinfo]invoiceBill.crdbLineItems.concat(readonlyCrdbLineItems.map(x => ({...x, fromRelatedEntity: true}))
              invoiceBill?.crdbLineItems.concat(readonlyCrdbLineItems.map(x => ({...x, fromRelatedEntity: true} as SalesCostCrDb)))??[]
            }
            tableStorage={tableStorage}
            isView={isView || (opBlockAfterClose && acctClose) || (opBlockAfterClose&& operClose)}
            height={crdbHeight}
            previewReport={PreviewReport}
            beforeBillInvoiceCrdbOpen={beforeBillInvoiceCrdbOpen}
          />
        </div>
      </div>
      }

      <IfmsModal
        isBlueHeader
        onCancel={() => setShowBillSummary(false)}
        draggable
        isOpen={showBillSummary}
        title="Bill Detail"
        // width="1590px"
        width="1350px"
      >
        <BillInvoiceSummaryTable summary={summary?.billSummary ?? []} isInvoice={false} />
        <div className='overall-footer'>
          <SecondaryButton size="regular" onClick={() => setShowBillSummary(false)}>CANCEL</SecondaryButton>
        </div>
      </IfmsModal>

      <IfmsModal
        isBlueHeader
        onCancel={() => setShowBillingOverall(false)}
        draggable
        isOpen={showBillingOverall}
        title="Billing Overall"
        // width="1590px"
        width="1350px"
      >
        <Label bold label="● Bill" style={{ marginLeft: '20px', fontSize: '13px' }} />
        <BillInvoiceSummaryTable summary={summary?.billSummary ?? []} isInvoice={false} height={'180px'} hideCrdb={hideCrdb}/>
        <Label bold label="● Invoice" style={{ marginLeft: '20px', fontSize: '13px' }} />
        <BillInvoiceSummaryTable summary={summary?.invoiceSummary ?? []} isInvoice={true} height={'180px'} hideCrdb={hideCrdb} />
        {!hideCrdb && 
        <>
        <Label bold label="● CrDb" style={{ marginLeft: '20px', fontSize: '13px' }} />
        <CrDbSummaryTable summary={summary?.crdbSummary ?? []} height={'180px'} parentType={parentType} />
        </>}
        <div className='overall-footer'>
          <SecondaryButton size="regular" onClick={() => setShowBillingOverall(false)}>CANCEL</SecondaryButton>
        </div>
      </IfmsModal>
      
      <IfmsModal
        isBlueHeader
        onCancel={() => setShowInvoiceSummary(false)}
        draggable
        isOpen={showInvoiceSummary}
        title="Invoice Detail"
        // width="1590px"
        width="1350px"
      >
        <BillInvoiceSummaryTable summary={summary?.invoiceSummary ?? []} isInvoice={true} />
        <div className='overall-footer'>
          <SecondaryButton size="regular" onClick={() => setShowInvoiceSummary(false)}>CANCEL</SecondaryButton>
        </div>
      </IfmsModal>
      <IfmsModal
        isBlueHeader
        onCancel={() => setShowCrdbSummary(false)}
        draggable
        isOpen={showCrdbSummary}
        title="CrDb Detail"
        width="1350px"
      >
        <CrDbSummaryTable summary={summary?.crdbSummary ?? []} parentType={parentType}/>
        <div className='overall-footer'>
          <SecondaryButton size="regular" onClick={() => setShowCrdbSummary(false)}>CANCEL</SecondaryButton>
        </div>
      </IfmsModal>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

export default SalesCostEntry;
